'use client'

import { useLocale } from '@/components/LocaleProvider'

export default function SkipLink() {
  const { t } = useLocale()
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:rounded focus:font-medium focus:bg-black focus:text-white dark:focus:bg-white dark:focus:text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black dark:focus-visible:outline-white"
    >
      {t('common.skipToContent')}
    </a>
  )
}
